import { Component, Input } from '@angular/core';
import { ZodiacCard } from 'src/app/mystery-school/mystery-school-dashboard/mystery-school-dashboard.component';

@Component({
  selector: 'app-zodiac-card',
  templateUrl: './zodiac-card.component.html',
  styleUrls: ['./zodiac-card.component.scss'],
})
export class ZodiacCardComponent {
  @Input() card!: ZodiacCard;
}
